/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailedReservationOperation
 */
export interface FailedReservationOperation {
    /**
     * A wall-clock time with no date or zone, as HH:mm or HH:mm:ss.
     * @type {string}
     * @memberof FailedReservationOperation
     */
    localEndTime: string;
    /**
     * A wall-clock time with no date or zone, as HH:mm or HH:mm:ss.
     * @type {string}
     * @memberof FailedReservationOperation
     */
    localStartTime: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof FailedReservationOperation
     */
    reservationId: string;
}

/**
 * Check if a given object implements the FailedReservationOperation interface.
 */
export function instanceOfFailedReservationOperation(value: object): value is FailedReservationOperation {
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('reservationId' in value) || value['reservationId'] === undefined) return false;
    return true;
}

export function FailedReservationOperationFromJSON(json: any): FailedReservationOperation {
    return FailedReservationOperationFromJSONTyped(json, false);
}

export function FailedReservationOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailedReservationOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'reservationId': json['reservationId'],
    };
}

export function FailedReservationOperationToJSON(value?: FailedReservationOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'reservationId': value['reservationId'],
    };
}

